import * as ActionType from 'constants/action-types/gimac';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.GIMAC_MERCHANT_PAY_START:
      return {
        ...state,
        merchantPay: {
          ...state.merchantPay,
          loading: true,
          error: null,
        },
      };
    case ActionType.GIMAC_MERCHANT_PAY_SUCCESS:
      return {
        ...state,
        merchantPay: {
          ...state.merchantPay,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.GIMAC_MERCHANT_PAY_FAILURE:
      return {
        ...state,
        merchantPay: {
          ...state.merchantPay,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.GIMAC_MERCHANT_PAY_CLEAR:
      return {
        ...state,
        merchantPay: {
          ...state.merchantPay,
          data: null,
          error: null,
          loading: false,
        },
        transferConfirmation: {
          ...state.transferConfirmation,
          data: null,
          error: null,
          loading: false,
        },
      };
    default:
      return null;
  }
};
